// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ArticleTagListTag{background-color:#919195;color:#fff;display:inline-block;font-size:.875rem;margin-bottom:.25rem;margin-right:.25rem;padding:.25rem 1rem;white-space:nowrap}.ArticleTagListTag:hover{background-color:#bcbcc0;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
